import React from 'react';
import { AlertItem } from '../../Services/serviceURL';
import DangerRedIcon from '../../Images/Danger-red-icon.png';
import WarningYellowIcon from '../../Images/Warning-yellow-icon.png';
import { formatAlertTime, getSeverityClass } from './summaryFormatUtils';
import { getAlertReasonLabel, isCriticalOrDangerSeverity } from './summaryAlertUtils';

type Props = {
  alert: AlertItem;
};

const SummaryAlertListItem: React.FC<Props> = ({ alert }) => {
  const severityClass = getSeverityClass(alert.severity);
  const showDangerIcon = isCriticalOrDangerSeverity(severityClass);
  const showWarningIcon = severityClass === 'warning';

  return (
    <div className={`alert-item ${severityClass}`}>
      {showDangerIcon && (
        <span className="alert-icon">
          <img src={DangerRedIcon} alt="Danger" width={40} height={40} />
        </span>
      )}
      {showWarningIcon && (
        <span className="alert-icon">
          <img src={WarningYellowIcon} alt="Warning" width={40} height={40} />
        </span>
      )}
      <div className="alert-details">
        <div className="alert-message">
          <span>Reason:</span> {getAlertReasonLabel(alert)}
        </div>
        <div className="alert-description">
          <strong>Attribute:</strong> {alert.attribute || 'N/A'}
          {alert.value !== undefined && (
            <span>
              {' '}
              | <strong>Value:</strong> {alert.value}
            </span>
          )}
        </div>
        <div className="alert-timestamp">
          <strong>Alert Time:</strong> {formatAlertTime(alert.alertTime)}
        </div>
      </div>
      <span className={`alert-severity ${severityClass}`}>{alert.severity || 'Unknown'}</span>
    </div>
  );
};

export default SummaryAlertListItem;
